import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';
import CoreEvents from '../../core/events/CoreEvents';

const _dispatcher = CoreMessageDispatcher.instance();

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr._update(true);
    mdr._updateItems(true);
    _addCoreListeners(mdr, true);

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    _addCoreListeners(mdr, false);

    mdr.started = false;
    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    mdr.state.isOn = mdr.model.menuOn;
    mdr.state.disabled = !mdr.model.menuAvailable;

    // View: can be substituted by JS-animation
    mdr.el.dataset.isOn = mdr.state.isOn;
    mdr.el.dataset.disabled = mdr.state.disabled;

    if (mdr.elsToMirrorState) {
        mdr.elsToMirrorState.forEach(el => {
            el.dataset.menuIsOn = mdr.state.isOn;
            el.dataset.menuIsDisabled = mdr.state.disabled;
        });
    }

    return mdr;
};

const _updateItems = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    if (mdr.state.currentItemId && mdr.itemsById[mdr.state.currentItemId]) {
        mdr.itemsById[mdr.state.currentItemId].classList.remove('active');
    }

    mdr.state.currentItemId = mdr.model.currentEventId;

    // View: can be substituted by JS-animation
    if (!mdr.state.currentItemId || !mdr.itemsById[mdr.state.currentItemId]) return mdr;

    mdr.itemsById[mdr.state.currentItemId].classList.add('active');

    return mdr;
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(CoreEvents.MODEL_STATE_CHANGED, mdr._updateItems);
        _dispatcher.on(CoreEvents.MENU_STATE_CHANGED, mdr._update);
        return;
    }

    _dispatcher.off(CoreEvents.MODEL_STATE_CHANGED, mdr._updateItems);
    _dispatcher.off(CoreEvents.MENU_STATE_CHANGED, mdr._update);
};

//

//
// Constructor
//
const MenuMediator = (el, model, elsToMirrorState) => {
    const mdr = {
        el: el,
        elsToMirrorState: elsToMirrorState instanceof Array ? elsToMirrorState : null,
        model: model,
        state: {
            isOn: false,
            currentItemId: null
        }
    };

    const items = [...el.querySelectorAll('.ui-nav')];
    const itemsByEventId = {};
    let i;
    let item;
    for (i = 0; i < items.length; i++) {
        item = items[i];
        itemsByEventId[item.dataset.eventId] = item;
    }
    mdr.itemsById = itemsByEventId;

    mdr.start = () => {
        return _start(mdr);
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr._updateItems = force => {
        return _updateItems(mdr, force);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    return mdr;
};

export {MenuMediator};
export default MenuMediator;
